export interface ConfigurationModel {
  dynamicProductFundRelation: boolean;
  dynamicProductRiskProfiles: boolean;
  fundMaintenance: boolean;
  allowEditNavValues: boolean;
  allowWithdrawFundAmount: boolean;
  allowCorrectionFundAmount: boolean;
  allowTransferFundAmount: boolean;
  demoMode: boolean;
  showDisbursements: boolean;
  allowEditEmailTemplates: boolean;
  allowDepositExport: boolean;
  tradeExternally: boolean;
  onlyAllowFictionalUnits: boolean;
  accountNeedsIdentification: boolean;
  showHistoricFundValues: boolean;
  createAccountsExternal: boolean;
}

export class Configuration implements ConfigurationModel {
  dynamicProductFundRelation = false;
  dynamicProductRiskProfiles = false;
  fundMaintenance = false;
  allowEditNavValues = false;
  allowWithdrawFundAmount = false;
  allowCorrectionFundAmount = false;
  allowTransferFundAmount = false;
  demoMode = false;
  showDisbursements = false;
  allowEditEmailTemplates = false;
  allowDepositExport = false;
  tradeExternally = false;
  onlyAllowFictionalUnits = false;
  accountNeedsIdentification = false;
  showHistoricFundValues = false;
  createAccountsExternal = false;

  constructor(dto?: ConfigurationModel) {
    if (!dto) {
      return;
    }

    Object.assign(this, dto);
  }
}
